import React, { Component } from "react";
import classnames from "classnames";

import { formatNumber } from "@formant/core/common/formatNumber";

import { CircleButton } from "../common/CircleButton";
import * as styles from "./Pagination.scss";

export interface IPaginationProps {
    page: number;
    total: number;
    perPage: number;
    className?: string;
    onChange: (page: number) => void;
}

export class Pagination extends Component<IPaginationProps> {
    public render() {
        const { page, total, perPage, className } = this.props;

        const pages = Math.ceil(total / perPage);
        if (pages <= 1) {
            return false;
        }

        return (
            <div className={classnames(styles.pagination, className)}>
                <CircleButton
                    icon="previous"
                    disabled={page === 0}
                    className={styles.button}
                    onClicked={this.onPrevious}
                />
                <div className={styles.current}>
                    {page * perPage + 1}-{Math.min(total, (page + 1) * perPage)}{" "}
                    of {formatNumber(total)}
                </div>
                <CircleButton
                    icon="next"
                    disabled={page === pages - 1}
                    className={styles.button}
                    onClicked={this.onNext}
                />
            </div>
        );
    }

    private onPrevious = () => {
        const { page, onChange } = this.props;
        onChange(page - 1);
    };

    private onNext = () => {
        const { page, onChange } = this.props;
        onChange(page + 1);
    };
}
